module.exports = __webpack_public_path__ + "img/female.3472a4d0.svg";